import ConsumerRefService from "@api/consumer/consumerRefService";
import {IRef} from "@interfaces/consumer/refs";
import {FC, useCallback} from "react";
import {toastr} from "@/utils/toastHelper";
import RefForm from "./refForm";
import {RefFormValues} from "./forms/refBaseInfoBlock";
import {TargetType} from "@components/consumer/refs/forms/refBaseInfoBlock";

interface EditRefFormProps {
    refObj: IRef;
}

const EditRefForm: FC<EditRefFormProps> = ({ refObj: ref }) => {

    const initialValues: RefFormValues = {
        name: ref.name,
        description: ref.description || '',
        targetType: ref.allTargets ? TargetType.All : TargetType.One,
        hidden: ref.hidden,
        isActive: ref.isActive,
        order: ref.order
    }

    const onSubmit = useCallback(async (values: RefFormValues) => {
        const api = new ConsumerRefService();
        const result = await api.patchRef({
            id: ref.id,
            name: values.name,
            description: values.description,
            hidden: values.hidden,
            allTargets: values.targetType === TargetType.All,
            isActive: values.isActive,
            order: values.order
        });

        if (result.success) {
            toastr.success('Реферальная система', 'Бонус обновлен');
        }
        else {
            if (result.errorCode === '') {
                toastr.error('Реферальная система', 'Бонус не найден');
            }
            else {
                toastr.error('Реферальная система', 'Неизвестная ошибка');
            }
        }
    }, [ref.id]);

    const onDelete = useCallback(async () => {
        const api = new ConsumerRefService();
        const result = await api.deleteRef(ref.id);

        if (result.success) {
            toastr.success("Удаление бонуса", "Бонус успешно удален");
        }
        else {
            if (result.errorCode === 'RefNotFound') {
                toastr.error('Удаление бонуса', 'Бонус не найден');
            }
            else {
                toastr.error('Удаление бонуса', 'Неизвестная ошибка');
            }
        }
    }, [ref.id]);

    return (
        <RefForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            onDelete={onDelete}
            editForm={true}
            cancelUrl={`/consumer/refs/${ref.id}/`} />
    )
}

export default EditRefForm;
